const genderArray = ["Male", "Female", "Not Specified"];
export default genderArray;
